import { GlobalFilter } from "../../shell/types"
import { IFieldFilter } from "../service"

export function createFilter(host: { filter: IFieldFilter }): GlobalFilter {

    return {

        get isActive() {
            return host.filter && (!host.filter.isEmpty())
        },

        get popupTemplate() {
            return "app/fields/filter/popup.html"
        },

        get statusText() {

            const f = host.filter

            if (f) {

                return [
                    f.field,
                    f.crop?.name,
                    f.cropDescr
                ].filter(t => !!t).join(", ")

            }
        }

    }

}
